import { useLocalStorage } from '@vueuse/core';

export const useCookieConsent = () => {
  const cookieConsent = useLocalStorage('cookieConsent', {
    essential: false,
    thirdParty: false,
  });
  const required = computed(() => !cookieConsent.value.essential);

  const acceptAll = () => {
    cookieConsent.value = {
      essential: true,
      thirdParty: true,
    };
  };

  const acceptEssential = () => {
    cookieConsent.value = {
      essential: true,
      thirdParty: false,
    };
  };

  const rejectAll = () => {
    cookieConsent.value = {
      essential: false,
      thirdParty: false,
    };
  };

  return { cookieConsent, required, rejectAll, acceptAll, acceptEssential };
};
